import { Link } from 'react-router-dom';

export default function DotLogo() {
    return (  
        <Link 
            to="/"
            aria-label="Home Page Link"
        >
            <img 
                src={`${process.env.PUBLIC_URL}/dotLogoAndSiteName.svg`}
                alt="Dot Foods"
            />    
        </Link>  
    );
};